module.exports = __webpack_public_path__ + "static/media/style delights.ad4f4dd0.jpg";